import React from "react";
import ReactLoading from "react-loading";

export default function LoadPage() {
  return (
    <div className="justify-center pt-40 m-auto">
      <ReactLoading
        className="m-auto"
        type={"bars"}
        color={"#005b95"}
        height={150}
        width={150}
      />
    </div>
  );
}
